import { NgModule } from '@angular/core';
import { PdfCoreModule } from './pdf-core';
import { VideoCoreModule } from './video-core';
import { BackgroundCoreModule } from './background-core';
import { VoiceCoreModule } from './voice-core/voice-core.module';
import { MusicCoreModule } from './music-core';
import { CharacterCoreModule } from './character-core';
import { FilesCoreModule } from './files-core';

@NgModule({
  declarations: [],
  imports: [],
  exports: [
    VideoCoreModule,
    PdfCoreModule,
    BackgroundCoreModule,
    VoiceCoreModule,
    MusicCoreModule,
    CharacterCoreModule,
    FilesCoreModule,
  ],
})
export class Level1GameCoreModule {}
